/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-04-22 19:34:44
 * @FilePath: /insuranceagent-ui/src/mixins/mixinsPolicyDownload.js
 * @Description:
 */
import eventBusKey from '@/util/eventBus'
import {getPolicyDetailLogListObj, getPolicyLogListObj} from '@/util/userLog'
export const mixinsPolicyDownload = {
	mounted() {
		this.$Bus.$on(eventBusKey.BusPolicyPdfDownload, this.onUpdatePolicyLogList)
	},
	beforeDestroy() {
		this.$Bus.$off(eventBusKey.BusPolicyPdfDownload, this.onUpdatePolicyLogList)
	},
	methods: {
		/**
		 * 获取数据 发票 和批单界面
		 * @param {*} response
		 */
		async onGetPolicyLogList(response = null) {
			try {
				if (response) {
					//页面数据
					let resData = await getPolicyLogListObj(response, this.fileType, 'endorseNo', 'policyNo')
					console.log('resData----', resData)
					//处理数据
					this.listData = this.listAfterData ? this.listAfterData(resData) : resData
				} else if (this.pdfDataList) {
					//dialog
					this.pdfDataList = await getPolicyDetailLogListObj(this.pdfDataList)
				}
			} catch (error) {
				this.$alert(`获取发票下载状态失败，${error.message}`, '提示').then(() => {})
			}
		},

		/**
		 * 更新保单下载状态
		 * @param {Object} data 数据
		 */
		onUpdatePolicyLogList(data = []) {
			console.log('onUpdatePolicyLogList----', data)
			for (let i = 0; i < data.length; i++) {
				//获取页面路径
				let eventKey = data[i]
				let tempType = eventKey.split('_')[0]

				//区分两种， PDF dialog 或者页面
				if (this.pdfDataList) {
					//dialog
					for (let i = 0; i < this.pdfDataList.length; i++) {
						let item = this.pdfDataList[i]
						let {label = '', value = []} = item
						//用 find
						let tempData = value.find(({endorseNo, policyNo}) => eventKey === `${label}_${endorseNo || policyNo}`)
						if (tempData) {
							this.$set(tempData, 'isDownload', true)
							//退出
							break
						}
					}
				} else if (this.listData) {
					console.log('mixinsPolicyDownload------->', this.fileType, tempType, !this.fileType.includes(`${tempType}`))
					if (!this.fileType.includes(`${tempType}`)) {
						continue
					}
					let tempData = this.listData.find(
						({endorseNo, policyNo}) => eventKey === `${tempType}_${endorseNo || policyNo}`,
					)
					if (tempData) {
						this.$set(tempData, 'isDownload', true)
					}
				}
			}
		},
	},
}
